<template>
  <layout>
    <section class="devices-settings">
      <api-tokens v-if="available && hasAccess"></api-tokens>
      <div v-else-if="!available" class="p-3 p-md-5">
        <h3>{{ $t('features.notConnected') }}</h3>
        <router-link class="nav-link px-0 col-sm-4" :to="{ name: 'MarketFeatures' }">
          <b-btn large variant="primary" class="btn-md btn-block">
            <span class="h4">{{ $t('features.toFeatures') }}</span>
          </b-btn>
        </router-link>
      </div>
    </section>
  </layout>
</template>

<script>
export default {
  name: 'ApiSettings',
  computed: {
    hasAccess() {
      return this.$store.getters.isAdmin;
    },
    available() {
      return this.hasFeature('api');
    },
  },
};
</script>
